var attributes = {
    HIGHLIGHT_FIRST: 'highlight-first',
    POPUP_CLASSES: 'popup-classes',
    OPTION_LIMIT: 'option-limit',
    OBSERVE_SCROLL: 'observe-scroll',
    OBSERVE_SCROLL_THRESHOLD: 'observe-scroll-threshold',
    SYNC_POPUP_WIDTH: 'sync-popup-width',
    // Internal
    CHECKBOX_ELEMENT: 'data-list-dropdown-checkbox'
};
var selectors = {
    DIALOG_SCROLL_CONTAINER: 'tcw-scaffold > div[slot=body]'
};
var classes = {
    GROUP_WRAPPER: 'tyl-list-dropdown__group-wrapper'
};
export var LIST_DROPDOWN_CONSTANTS = {
    attributes: attributes,
    selectors: selectors,
    classes: classes
};
export var DEFAULT_LIST_DROPDOWN_CONFIG = {
    options: [],
    syncWidth: false,
    selectedValues: [],
    multiple: false,
    highlightFirst: true
};
export var ListDropdownType;
(function (ListDropdownType) {
    ListDropdownType["None"] = "none";
    ListDropdownType["Standard"] = "standard";
    ListDropdownType["Menu"] = "menu";
})(ListDropdownType || (ListDropdownType = {}));
export var ListDropdownAsyncStyle;
(function (ListDropdownAsyncStyle) {
    ListDropdownAsyncStyle["Spinner"] = "spinner";
    ListDropdownAsyncStyle["Skeleton"] = "skeleton";
})(ListDropdownAsyncStyle || (ListDropdownAsyncStyle = {}));
